import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from './SubscriptionContext'; // Import SubscriptionContext
import LaundryImage from "./laundry.jpg";
import { useUser } from "./UserContext"; // Import UserContext
import "./Dashboard2.css";
const SubscriptionCard = () => {
  const { subscription, upgradePlan, cancelSubscription } = useSubscription();
  const { user } = useUser();
  const navigate = useNavigate();

  console.log('Subscription:', subscription);
  console.log('User:', user);

  return (<>
  {!subscription ? (
          <div className="container" style={{marginTop:"-12px"}}>
      
		 
          <div className="row justify-content-center">
            <div className="col-md-4 justify-content-center">
              <div className="subscription-card justify-content-center text-center">
                <img className="rounded" src={LaundryImage} style={{ width: "200px" }} alt="Laundry" />
                <h4>Basic Plan</h4>
                <p>Includes 5 washing bags per month.</p>
                <p>Price: R89.99/month</p>
                <button onClick={() => navigate('/subscription', { state: { plan: { name: 'Basic Plan', priceInCents: 8999 } } })}>
                  Subscribe Now
                </button>
              </div>
            </div>
            <div className="col-md-4 justify-content-center">
              <div className="subscription-card justify-content-center text-center">
                <img className="rounded" src={LaundryImage} style={{ width: "200px" }} alt="Laundry" />
                <h4>Standard Plan</h4>
                <p>Includes 10 washing bags per month.</p>
                <p>Price: R114.99/month</p>
                <button onClick={() => navigate('/subscription', { state: { plan: { name: 'Standard Plan', priceInCents: 11499 } } })}>
                  Subscribe Now
                </button>
              </div>
            </div>
            <div className="col-md-4 justify-content-center">
              <div className="subscription-card justify-content-center text-center">
                <img className="rounded" src={LaundryImage} style={{ width: "200px" }} alt="Laundry" />
                <h4>Premium Plan</h4>
                <p>Includes unlimited washing bags.</p>
                <p>Price: R150.99/month</p>
                <button onClick={() => navigate('/subscription', { state: { plan: { name: 'Premium Plan', priceInCents: 15099 } } })}>
                  Subscribe Now
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
		<div className="container justify-content-center" style={{marginTop:"-12px"}}>
		<br/><br/><br/>
		<div className="row justify-content-center">
			<div className="col-md-4 justify-content-center">
				<div className="subscription-card justify-content-center text-center">
					<h3>Current Subscription</h3>
					<div onClick={() => navigate('/subscription-page')} className="subscription-card">
						<img className="rounded" src={LaundryImage} style={{ width: "200px" }} alt="Laundry" />
						<h4>{subscription.planName}</h4>
						<p>Price: R{(subscription.priceInCents / 100).toFixed(2)} per month</p>
						<p>Status: {subscription.status}</p>
						<center><button onClick={() => navigate('/manage-subscription')}>Manage</button></center>
					</div>
				</div>
			</div>
			</div>
		</div>
      )}
	  <hr/>
	  <div className="card justify-content-center text-center" style={{margin:"auto",width:"96vw",maxWidth:"500px",padding:"20px"}}>
	  <h2>Don't want a subscription ?</h2>
   	<button onClick={()=>navigate("/order")} style={{margin:"auto"}} className="btn-ltd button">Place A Once Off Order</button>
           </div>                 
  </>);
};

export default SubscriptionCard;
